<template>
  <div class="ArticleList">
    <ul>
      <li @click="$router.push({path:'/AboutUs'});" :class="{act:$route.path == '/AboutUs'}">关于我们</li>
      <li @click="$router.push({path:'/AdCooperation'});" :class="{act:$route.path == '/AdCooperation'}">广告合作</li>
      <li @click="$router.push({path:'/EliteRecruitment'});" :class="{act:$route.path == '/EliteRecruitment'}">精英招聘</li>
      <li @click="$router.push({path:'/Feedback'});" :class="{act:$route.path == '/Feedback'}">意见反馈</li>
      <li @click="$router.push({path:'/TermsOfUse'});" :class="{act:$route.path == '/TermsOfUse'}">使用条款</li>
      <li @click="$router.push({path:'/ContactUs'});" :class="{act:$route.path == '/ContactUs'}">联系我们</li>
    </ul>
  </div>
</template>
<script>
export default {
  data () {
    return {
      
    }
  },
  props: ['article'],
  created () {
    
  },
  methods: {
    
  }
}
</script>
<style scoped>
  .ArticleList{
    margin-top:30px;
    width:220px;
    max-width:100%;
    overflow:hidden;
  }
  .ArticleList ul{
    margin:0px;padding: 0px;
  }
  .ArticleList ul > li{
    list-style: none;
    background-color:#fff;
    text-align:center;
    line-height:50px;
    cursor: pointer;
    border-right: 5px solid #fff;
  }
  .ArticleList ul > li.act,.ArticleList ul > li:hover{
    background-color: #f4f6f9;
    border-right: 5px solid #76b1f6;
  }
</style>


// WEBPACK FOOTER //
// ArticleList.vue?86956e20